import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { AutoComplete, Input } from 'antd';
const renderTitle = (title) => (_jsx("span", { children: title }));
const renderItem = (title, count) => ({
    value: title,
    label: (
    // <div
    //   style={{
    //     display: 'flex',
    //     justifyContent: 'space-between',
    //   }}
    // >
    _jsx(_Fragment, { children: title })
    // </div>
    ),
});
export function SearchBar({ data, options, placeholder, handleOnSelect, handleSearch, size, clearAutoComplete, handleSearchIconClick }) {
    const [autoCompleteOptions, setAutoCompleteOptions] = useState();
    //const [autoCompleteValue, setAutoCompleteValue] = useState(value);
    const [autoCompleteValue, setAutoCompleteValue] = useState(undefined);
    // const clearAutoComplete = () => {
    //   setAutoCompleteValue('');
    // };
    useEffect(() => {
        const options = [];
        for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
                const values = data[key];
                let x = {
                    label: renderTitle(key),
                    options: []
                };
                values.forEach((value, index) => {
                    x === null || x === void 0 ? void 0 : x.options.push(renderItem(value, index));
                });
                options.push(x);
            }
        }
        setAutoCompleteOptions(options);
    }, [data]);
    useEffect(() => {
        if (clearAutoComplete) {
            setAutoCompleteValue(undefined); // Reset autocomplete value
        }
    }, [clearAutoComplete]);
    return _jsx(AutoComplete, { style: { width: '29%', height: '24px' }, options: options || autoCompleteOptions, value: autoCompleteValue, onSelect: handleOnSelect, onSearch: handleSearch, size: "large", children: _jsx(Input.Search, { size: size || 'small', style: { width: '90%' }, enterButton: true, placeholder: placeholder, onSearch: handleSearchIconClick }) });
}
;
export default SearchBar;
